import { useEffect, useState } from "react";
import API from "../Network/API";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import PostLoader from '../assets/loader.gif';

import { useSelector } from "react-redux";
import CardPayment from "../components/CardPayment";
import UserAvatar from "../components/UserAvatar";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import moment from "moment";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

export default function Checkout() {

  const [clientSecret, setClientSecret] = useState("");
  const { user, accessToken } = useSelector((state) => state.authReducer);
  const prams = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const isAppRoute = location.pathname.startsWith("/app");
  const [data, setData] = useState();
  const [isLoading, setLoading] = useState(false);
  const [timezone, setTimezone] = useState('');
  const [fee, setFee] = useState(0);
  const event = JSON.parse(localStorage.getItem("event"));
  const lesson = JSON.parse(localStorage.getItem("lesson"));
  const isFree = data != null && Number(data?.price ?? 0) <= 0;
  const hasReviews = Number(data?.avg_rating ?? 0) > 0 && Number(data?.total_review ?? 0) > 0;

  useEffect(() => {

  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const cart = JSON.parse(localStorage.getItem("data_checkout"));
    setData(cart)

    setTimezone(timezone);

    // free orders skip Stripe entirely — no payment intent needed
    if (Number(cart?.price ?? 0) <= 0) {
      return;
    }

    setLoading(true)
    const formData = new FormData()
    formData.append('amount', cart?.price)
    API.post(`/v1/oauth/create-payment-intent`, formData).then((response) => {
      setClientSecret(response.data.clientSecret)
      setLoading(false)
    }).catch((error) => {
      setLoading(false)
    });


  }, [prams.slug]);

  // free enrollment goes through the same order pipeline, just without a Stripe payment
  const enrollFree = () => {
    navigate(`${isAppRoute ? '/app' : ''}/order/process?redirect_status=succeeded&payment_intent=free_checkout`);
  };




  const appearance = {
    theme: 'stripe',
    variables: {
      // colorPrimary: '#0570de',
      // colorBackground: '#ffffff',
      // colorText: '#303238',
      // colorDanger: '#df1b41',
      // fontFamily: 'Helvetica Neue, Helvetica, sans-serif',
      // spacingUnit: '2px',
      // borderRadius: '4px',
    },
  };
  const options = {
    clientSecret,
    appearance,
  };

  return (
    <>
      {isLoading ?
        <div className='content' style={{ margin: 'auto', padding: 'auto', textAlign: 'center', height: '500px' }}>
          <img src={PostLoader} alt='Post loader' height={80} width={80} />
        </div>
        :
        <div className="payment-checkuot">
          <div className="container">
            <div className="row m-0">
              <div className="col-md-7 col-12">
                <div className="box-right ">
                  <div className="row">
                    <div className="col-12">
                      <div className="checkout-course-head d-flex">
                        <div className="flex-shrink-0">
                          <UserAvatar src={data?.teacher_image} name={data?.teacher_name} size={64} />
                        </div>
                        <div className="flex-grow-1 ms-3 min-w-0">
                          <p className="checkout-kicker mb-1">
                            {data?.course_type === 'recorded' ? 'Recorded course' : 'Live lesson'}
                          </p>
                          <h4 className="checkout-course-title">{data?.course_title}</h4>
                          {data?.course_type !== 'recorded' && lesson?.title &&
                            <p className="checkout-lesson-line mb-1"><i className="fa-light fa-book-open me-2" />{lesson.title}</p>
                          }
                          <p className="checkout-teacher-line mb-0">
                            with <b>{data?.teacher_name}</b>
                            {hasReviews &&
                              <span className="checkout-rating ms-2">
                                <i className="fa-solid fa-star" /> {data?.avg_rating}
                                <span className="checkout-rating-count"> ({data?.total_review} review{Number(data?.total_review) === 1 ? '' : 's'})</span>
                              </span>
                            }
                          </p>
                          <div className="checkout-chips mt-2">
                            <span className="checkout-chip"><i className="fa-light fa-badge-check me-1" />Verified</span>
                            <span className="checkout-chip"><i className="fa-light fa-award me-1" />Professional</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={`row justify-content-center ${data?.course_type=='recorded'?'d-none':'d-block'}`}>
                    <div className="col-md-10 d-none">
                      <div className="checkoutHeading-payment-form-btn mt-4">
                        {/* Credit card form tabs */}
                        <ul role="tablist" className="nav bg-light nav-pills rounded nav-fill mb-3 checkoutPayment">
                          <li className="nav-item"> <a data-toggle="pill" href="#credit-card" className="nav-link active "> <span className="d-block fw-bold">25 mins</span> <span className="d-block fw-bold">BDT 1,208</span></a> </li>
                          <li className="nav-item"> <a data-toggle="pill" href="#paypal" className="nav-link "> <span className="d-block fw-bold">50 mins</span> <span className="d-block fw-bold">BDT 1,908</span></a></li>
                        </ul>
                      </div> {/* End */}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <div className="Divider-sc" />
                    </div>
                  </div>
                  <div className={`row ${data?.course_type=='recorded'?'d-none':'d-block'}`}>
                    <div className="col-12">
                      <div className="course-schedule">
                        <p className="course-schedule-time mb-0">{ moment.tz(event?.start, timezone).format('YYYY-MM-DD hh:mm A') } {timezone}</p>
                        <p className="course-schedule-location mb-0">Time is based on your location</p>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <div className="Divider-sc" />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <div className="order-heading mb-3">
                        <h2>Your order</h2>
                      </div>
                      <div className="order-dec">
                        <div className="d-flex justify-content-between order-dec-item">
                          <p className="order-dec-item-name">Sub Total</p>
                          <p className="order-dec-item-price fw-bold">${Number(data?.price ?? 0).toFixed(2)}</p>
                        </div>
                      </div>
                      <div className="order-dec">
                        <div className="d-flex justify-content-between order-dec-item">
                          <p className="order-dec-item-name">Processing fee</p>
                          <p className="order-dec-item-price fw-bold">${Number(fee).toFixed(2)}</p>
                        </div>
                      </div>
                      <div className="order-dec mb-3">
                        <div className="d-flex justify-content-between mb-2 mt-2 order-dec-total-item">
                          <p className="order-dec-item-total-name">Total</p>
                          <p className="order-dec-item-total-price">${(Number(data?.price)+Number(fee)).toFixed(2)}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row d-none">
                    <div className="col-8">
                      <input className="form-control input-hight-44" type="text" placeholder="Enter your promo code" />
                    </div>
                    <div className="col-4">
                      <a href="#" className="btn rounded btn-light w-100 input-hight-44 pt-2">
                        Apply
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-5 col-12 ps-md-5 p-0 ">
                <div className="box-left">
                  {isFree ?
                    <div className="free-enroll-panel text-center">
                      <span className="free-enroll-badge"><i className="fa-light fa-gift me-2" />Free</span>
                      <h2 className="free-enroll-title">No payment needed</h2>
                      <p className="free-enroll-dec">This {data?.course_type === 'recorded' ? 'course' : 'lesson'} is free — enroll now and start learning right away.</p>
                      <button type="button" onClick={() => enrollFree()} className="btn rounded becomeTutor-btn w-100">
                        Enroll for Free<i className="fa-light fa-arrow-right ms-2" />
                      </button>
                      <p className="free-enroll-note">No card required. You'll get instant access.</p>
                    </div>
                    :
                    <div className="checkoutHeading-payment-form">
                      <div className="checkoutHeading-payment-form-btn">
                        {/* Credit card form tabs */}
                        <ul role="tablist" className="nav bg-light nav-pills rounded nav-fill mb-3 checkoutPayment">
                          <li className="nav-item"> <a data-toggle="pill" href="#credit-card" className="nav-link active "> <i className="fa-light fa-credit-card me-2" /> Checkout Now </a> </li>
                        </ul>
                      </div> {/* End */}
                      {/* Credit card form content */}
                      <div className="tab-content">
                        {/* credit card info*/}
                        <div id="credit-card" className="tab-pane fade show active pt-3 credit-card">
                          <div className="form">

                              {clientSecret && (
                                <Elements options={options} stripe={stripePromise}>
                                  <CardPayment data={data} price={(Number(data?.price)+Number(fee)).toFixed(2)}/>
                                </Elements>
                              )}


                          </div>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </>
  )
}